import { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import ClubInfosIndex from './ClubInfosIndex';
import ClubInfoDetailPage from './ClubInfoDetailPage';

const kakaoKey = import.meta.env.VITE_KAKAO_JAVASCRIPT_KEY;

const ClubInfosMain = () => {
  const { id } = useParams();

  useEffect(() => {
    const script = document.createElement('script');
    script.src = `//dapi.kakao.com/v2/maps/sdk.js?appkey=${kakaoKey}&libraries=services&autoload=false`;
    script.async = true;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script); // cleanup
    };
  }, []);

  return (
    <div className="mx-auto max-w lg:max-w-5xl bg-white p-6">
      {id ? <ClubInfoDetailPage id={parseInt(id)} /> : <ClubInfosIndex />}
    </div>
  );
};

export default ClubInfosMain;
